import { Modal, Button } from "react-bootstrap";
import { IoTrashOutline } from "react-icons/io5";

interface DeleteCampaignModalProps {
  show: boolean;
  campaignName?: string;
  isDeleting?: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteCampaignModal = ({
  show,
  campaignName,
  isDeleting = false,
  onHide,
  onConfirm,
}: DeleteCampaignModalProps) => {
  const displayName = campaignName?.trim() || "Untitled Campaign";

  return (
    <Modal show={show} onHide={isDeleting ? undefined : onHide} centered backdrop="static">
      <Modal.Header closeButton={!isDeleting}>
        <Modal.Title
          className="d-flex align-items-center gap-2"
          style={{ fontSize: "18px", fontWeight: 600, color: "#19222E" }}
        >
          <span
            className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              backgroundColor: "rgba(220, 53, 69, 0.1)",
              color: "#dc3545",
            }}
          >
            <IoTrashOutline size={18} />
          </span>
          Delete campaign?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ color: "#495057", fontSize: "15px", lineHeight: 1.5 }}>
        <p className="mb-2">
          Are you sure you want to delete{" "}
          <strong style={{ color: "#19222E" }}>{displayName}</strong>?
        </p>
        <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
          This will permanently remove the campaign and its recipients. This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} className="rounded" disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          className="rounded"
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete campaign"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCampaignModal;
